module.exports = __webpack_public_path__ + "static/media/india-post.676a85c5.svg";